import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { WorkspaceProvider } from "./context/WorkspaceContext";
import App from "./App";
import "./index.css";
import "./styles/tokens.css";
import "./styles/mobile.css";

const APP_BUILD = "2026-08-01-production-v2.6";
const BUILD_KEY = "gantt-pro.frontend-build";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
    mutations: { retry: false },
  },
});

// Evita que Chrome restaure desde BFCache una versión anterior del SPA al
// volver, cerrar sesión o iniciar sesión nuevamente.
window.addEventListener("pageshow", (event) => {
  if (event.persisted) window.location.reload();
});

const previousBuild = localStorage.getItem(BUILD_KEY);
localStorage.setItem(BUILD_KEY, APP_BUILD);
if (previousBuild && previousBuild !== APP_BUILD && !window.location.search.includes("fresh=")) {
  const separator = window.location.search ? "&" : "?";
  window.location.replace(`${window.location.pathname}${window.location.search}${separator}fresh=${Date.now()}`);
} else {
  if (window.location.search.includes("fresh=")) {
    const cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete("fresh");
    window.history.replaceState({}, "", `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`);
  }
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <WorkspaceProvider><App /></WorkspaceProvider>
          </AuthProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </React.StrictMode>,
  );
}
